module.exports = "/public/images/600caf17150ed8cf7828409b2235cdaa.png";